import Culture from "./Culture";
export default Culture;
